{
  "{platform} version {version} · update {update}": "Versão {version} para {platform} · atualização {update}",
  "{platform} version {version}": "Versão {version} para {platform}",
  "Delete my account, all personal data, and all video files streamed or uploaded online from EventLive servers": "Excluir dos servidores do EventLive minha conta, todos os meus dados pessoais e todos os vídeos transmitidos ou enviados",
  "Delete your Account? THIS ACTION IS IRREVERSIBLE": "Excluir sua conta? ESTA AÇÃO É IRREVERSÍVEL",
  "You have {count} prepaid event. It's used automatically when you create an event.": {
    "one": "Você tem {count} evento pré-pago. Ele é usado automaticamente quando você cria um evento.",
    "other": "Você tem {count} eventos pré-pagos. Um deles é usado automaticamente cada vez que você cria um evento."
  },
  "My Video Wall": "Meu Mural de vídeos",
  "Download Everything": "Baixar tudo",
  "Update Profile": "Atualizar perfil",
  "View Invoices and Manage Subscription": "Ver faturas e gerenciar assinatura",
  "Reset Password": "Redefinir senha",
  "Contact Support": "Falar com o suporte",
  "Review EventLive": "Avaliar o EventLive",
  "Delete Account": "Excluir conta",
  "Sign Out": "Sair",
  "{team}'s Team": "Equipe de {team}",
  "Team": "Equipe",
  "Over {limit} in all": "Mais de {limit} no total",
  "Ticketed: no limit": "Com ingresso: sem limite",
  "{hours} in all": "{hours} no total",
  "MMMM YYYY": "MMMM [de] YYYY",
  "{month} (so far)": "{month} (até agora)",
  "Couldn't load this month. Please try again.": "Não foi possível carregar este mês. Tente novamente.",
  "How many hours of your videos people watched each month, live and replay. Each event includes {limit} viewer-hours; ticketed events have no limit.": "Quantas horas dos seus vídeos as pessoas assistiram a cada mês, ao vivo e na gravação. Cada evento inclui {limit} horas-espectador; eventos com ingresso não têm limite.",
  "Viewer-hours are shown to business accounts.": "As horas-espectador são exibidas para contas empresariais.",
  "Couldn't load viewer-hours. Please try again later.": "Não foi possível carregar as horas-espectador. Tente novamente mais tarde.",
  "No viewer-hours yet. They're updated every hour, within an hour of people watching.": "Ainda não há horas-espectador. Elas são atualizadas a cada hora, até uma hora depois de as pessoas assistirem.",
  "Counted every hour from the video our CDN delivered, on every player. Months are in UTC, and an event's hours count in the month people watched. Test events aren't included.": "Contadas a cada hora a partir do vídeo entregue pela nossa CDN, em todos os players. Os meses seguem o horário UTC, e as horas de um evento contam no mês em que as pessoas assistiram. Eventos de teste não são incluídos.",
  "{extra} over {limit} this month": "{extra} acima de {limit} este mês",
  "{extra} extra viewer-hours on {count} event over {limit}": {
    "one": "{extra} horas-espectador extras em {count} evento acima de {limit}",
    "other": "{extra} horas-espectador extras em {count} eventos acima de {limit}"
  }
}
